export default [
  { value: 'new',        label: 'Новая',          color: '#a5d392', order: 1, }, // eslint-disable-line
  { value: 'progress',   label: 'В работе',       color: '#ffd059', order: 2, }, // eslint-disable-line
  { value: 'paused',     label: 'Пауза',          color: '#cbcbcb', order: 3, }, // eslint-disable-line
  { value: 'review',     label: 'Проверка',       color: '#3680CC', order: 4, }, // eslint-disable-line
  { value: 'rework',     label: 'На доработку',   color: '#7a5e9f', order: 5, }, // eslint-disable-line
  { value: 'agreement',  label: 'Согласование',   color: '#E86863', order: 6, }, // eslint-disable-line
  { value: 'closed',     label: 'Завершена',      color: '#8b8b8b', order: 7, }, // eslint-disable-line
];
